import { FC, Fragment, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { Menu, Transition } from "@headlessui/react";
import {
  UserCircleIcon,
  HeartIcon,
  // InboxInIcon,
  LogoutIcon,
  ArchiveIcon,
} from "@heroicons/react/solid";
// import { UploadIcon } from "@heroicons/react/outline";
import { Switch } from "@headlessui/react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "store";
import { userLogout } from "actions/userActions";
import { Link } from "react-router-dom";

interface IProfile {
  title: string;
  iconActive: JSX.Element;
  iconDeactive: JSX.Element;
  href: string;
}

const renterMenus: IProfile[] = [
  {
    title: "Profile",
    iconActive: <UserCircleIcon className="w-5 h-5 mr-2" />,
    iconDeactive: (
      <UserCircleIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
    ),
    href: "/account",
  },
  {
    title: "Whislist",
    iconActive: <HeartIcon className="w-5 h-5 mr-2" />,
    iconDeactive: (
      <HeartIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
    ),
    href: "/account-savelists",
  },
  // {
  //   title: "Pesanan Saya",
  //   iconActive: <UploadIcon className="w-5 h-5 mr-2" />,
  //   iconDeactive: (
  //     <UploadIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
  //   ),
  //   href: "/account-entries",
  // },
  {
    title: "Keluar",
    iconActive: <LogoutIcon className="w-5 h-5 mr-2" />,
    iconDeactive: (
      <LogoutIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
    ),
    href: "/login",
  },
];

const vendorMenus: IProfile[] = [
  {
    title: "Dashboard",
    iconActive: <UserCircleIcon className="w-5 h-5 mr-2" />,
    iconDeactive: (
      <UserCircleIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
    ),
    href: "/vendor-status",
  },
  {
    title: "Listing",
    iconActive: <ArchiveIcon className="w-5 h-5 mr-2" />,
    iconDeactive: (
      <ArchiveIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
    ),
    href: "/vendor-listing",
  },
  // {
  //   title: "Pesanan Masuk",
  //   iconActive: <InboxInIcon className="w-5 h-5 mr-2" />,
  //   iconDeactive: (
  //     <InboxInIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
  //   ),
  //   href: "/vendor-entries",
  // },
  {
    title: "Keluar",
    iconActive: <LogoutIcon className="w-5 h-5 mr-2" />,
    iconDeactive: (
      <LogoutIcon className="w-5 h-5 mr-2 text-primary-6000 dark:text-primary-6000" />
    ),
    href: "/login",
  },
];

const ProfileDropdown: FC = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  const [vendor, setVendor] = useState<boolean>(false);

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button
          className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-neutral-700
 dark:text-neutral-200 bg-black rounded-md bg-opacity-5 dark:bg-opacity-20 hover:bg-opacity-10 dark:hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
        >
          {userInfo && userInfo?.name.split(" ").length > 0
            ? userInfo?.name.split(" ")[0]
            : userInfo?.name}
          <ChevronDownIcon
            className="w-5 h-5 ml-2 -mr-1 text-neutral-900 dark:text-violet-200 hover:text-neutral-900 dark:hover:text-violet-100"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 w-56 mt-2 origin-top-right bg-white dark:bg-neutral-900  divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="p-2">
            <div className="p-3 flex items-center">
              <label
                className={`text-sm font-semibold text-primary-6000 ${
                  vendor && "opacity-30"
                } w-min`}
              >
                Renter
              </label>
              <Switch
                checked={vendor}
                onChange={setVendor}
                className={`${
                  vendor ? "bg-primary-6000 " : "bg-primary-6000 "
                } relative inline-flex items-center h-6 rounded-full w-11 mx-5 focus:ring-offset-0 focus:border-0 focus:border-black focus:ring-black`}
              >
                <span className="sr-only">Enable notifications</span>
                <span
                  className={`${
                    vendor ? "translate-x-6" : "translate-x-1"
                  } inline-block w-4 h-4 transform bg-white rounded-full`}
                />
              </Switch>
              <label
                className={`text-sm font-semibold text-primary-6000 ${
                  vendor || "opacity-30"
                } w-min`}
              >
                Vendor
              </label>
            </div>
            <hr className="my-2" />
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="/add-listing-1"
                  className="bg-primary-6000 hover:bg-primary-700 text-white group flex rounded-md items-center w-full p-3 text-sm mb-3"
                  target={"_parent"}
                >
                  Sewakan Barangmu
                </Link>
              )}
            </Menu.Item>
            {vendor
              ? vendorMenus.map((menu) => {
                  return (
                    <Menu.Item key={menu.title}>
                      {({ active }) => (
                        <Link
                          onClick={() => {
                            if (menu.title === "Keluar") {
                              dispatch(userLogout());
                            }
                          }}
                          to={menu.href}
                          className={`${
                            active
                              ? "bg-primary-6000 dark:bg-primary-6000  text-white"
                              : "text-gray-900 dark:text-white"
                          } group flex rounded-md items-center w-full p-3 text-sm`}
                        >
                          {active ? menu.iconActive : menu.iconDeactive}
                          {menu.title}
                        </Link>
                      )}
                    </Menu.Item>
                  );
                })
              : renterMenus.map((menu) => {
                  return (
                    <Menu.Item key={menu.title}>
                      {({ active }) => (
                        <Link
                          onClick={() => {
                            if (menu.title === "Keluar") {
                              dispatch(userLogout());
                            }
                          }}
                          to={menu.href}
                          className={`${
                            active
                              ? "bg-primary-6000 dark:bg-primary-6000  text-white"
                              : "text-gray-900 dark:text-white"
                          } group flex rounded-md items-center w-full p-3 text-sm`}
                        >
                          {active ? menu.iconActive : menu.iconDeactive}
                          {menu.title}
                        </Link>
                      )}
                    </Menu.Item>
                  );
                })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default ProfileDropdown;
